module.exports = __webpack_public_path__ + "img/35.f6349b98.png";